<template>
  <i18n-t :keypath="'NotificationsComponent.' + notification.type" tag="span" class="pl-quarter" scope="global">
    <template #link>
      <a id="linkToSupport" :href="getUrl('VITE_APP_WEBROOT_INSTALL_SUPPORT')" target="_blank">
        {{ t(notificationMessage) }}
      </a>
    </template>
    <template #keycode>
      <span>
        <strong>
          {{ t(keycode) }}
        </strong>
      </span>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { INotification } from "@/stores/notifications";
import { formatKeycode } from "@/common/formatKeycode";
import { getUrl } from "@/common/getUrl";

const componentName = "AddFraudKeyNotification";

export default defineComponent({
  name: componentName,
  props: {
    notification: {
      type: Object as PropType<INotification>,
      default: null,
    },
  },
  setup(props) {
    logEvent("created", componentName);

    const notificationMessage = ref<string>(props.notification?.params?.text ?? "");
    const keycode = ref<string>(formatKeycode(props.notification?.params?.keycode ?? ""));

    return { t, notificationMessage, keycode, getUrl };
  },
});
</script>
